import { render } from "./SmallLoader.vue?vue&type=template&id=39f60b31&scoped=true"
import script from "./SmallLoader.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SmallLoader.vue?vue&type=script&charset=utf-8&lang=js"

import "./SmallLoader.vue?vue&type=style&index=0&id=39f60b31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f60b31"]])

export default __exports__